import types from './actionTypes';

const actions = {
  showLoader: (payload) => {
    return {
      type: types.SHOW_LOADER,
      payload,
    };
  },
};

export default actions;